<div [formGroup]="form">
	<ng-container *ngIf="data?.type === 'REQUEST_WORK_FORCEPLAN' && data?.mode === 'add'">
		<div class="form-group">
			<label class="form-control-label" for="organic-planning-note">Justificativa</label>
			<textarea
				id="organic-planning-note"
				type="text"
				class="form-control"
				formControlName="note"
				rows="4"
				placeholder="Descreva o motivo da solicitação de planejamento de orgânico"
			></textarea>
			<app-error-msg [control]="noteControl" [label]="'Justificativa'"></app-error-msg>
		</div>
	</ng-container>

	<ng-container *ngIf="data?.mode === 'details'">
		<div class="solicitation-details-container">
			<div class="card-informations card card-fit shadow rounded-lg">
				<div class="card-infos-content">
					<strong>Tipo de solicitação</strong>
					<span>
						{{ data?.solicitation?.movementTypeData?.label }}
						<strong *ngIf="!!approvalDetails?.version">(v.{{ approvalDetails?.version }})</strong>
					</span>
				</div>
				<div class="sepator-vertical"></div>
				<div class="card-infos-content">
					<strong>Solicitante</strong>
					<div class="requester-infos">
						<img alt="avatar" class="avatar" [width]="32" [height]="32" [src]="
                data?.solicitation?.requesterImage ||
                'assets/images/logo/avatar-profile.png'
              " />
						<span>{{ data?.solicitation?.requesterName }}</span>
					</div>
				</div>
				<div class="sepator-vertical"></div>
				<div class="card-infos-content">
					<strong>Filial</strong>
					<span>{{ approvalDetails?.companyName }}</span>
				</div>
				<div class="sepator-vertical"></div>
				<div class="card-infos-content">
					<strong>Centro de Custo</strong>
					<span>{{ approvalDetails?.costCenterName }}</span>
				</div>
				<div class="sepator-vertical"></div>
				<div class="card-infos-content">
					<strong>Proposta Atual</strong>
					<span class="proposal-value-container" *ngIf="proposalChangeDirection as direction">
						<span [ngClass]="direction">{{ totalPlanned }}</span>
						<i
							*ngIf="direction === 'increase'"
							data-feather="arrow-up"
							class="mb-icon text-success"
							size="14"
						></i>
						<i
							*ngIf="direction === 'decrease'"
							data-feather="arrow-down"
							class="mb-icon text-danger"
							size="14"
						></i>
					</span>
				</div>
				<div class="sepator-vertical"></div>
				<div class="card-infos-content">
					<strong>Previsto Anterior</strong>
					<span>{{ totalEffective }}</span>
				</div>
			</div>

			<div class="note">
				<strong>Justificativa</strong>
				<p>{{ data?.solicitationDetails?.note || "Não informada" }}</p>
			</div>

			<div *ngIf="hasPreviousStepObservations" class="previous-observations card card-fit shadow rounded-lg">
				<button
					type="button"
					class="previous-observations__toggle"
					(click)="togglePreviousObservations()"
					[attr.aria-expanded]="!isPreviousObservationsCollapsed"
					aria-label="Alternar observações das etapas anteriores"
					aria-controls="previous-observations-collapse"
				>
					<div class="previous-observations__title-wrap">
						<strong>Observações das etapas anteriores</strong>
						<span class="previous-observations__count">{{ previousStepObservations.length }}</span>
					</div>
					<i
						class="feather"
						[ngClass]="isPreviousObservationsCollapsed ? 'icon-chevron-down' : 'icon-chevron-up'"
					></i>
				</button>

				<div id="previous-observations-collapse" [ngbCollapse]="isPreviousObservationsCollapsed" role="region">
					<div class="previous-observations__list">
						<div
							*ngFor="let item of previousStepObservations; trackBy: trackByStepId"
							class="previous-observations__item card card-fit"
						>
							<div class="previous-observations__meta">
								<div>
									<strong class="previous-observations__field-label">Etapa</strong>
									<span class="previous-observations__field-value">{{ getObservationStepLabel(item) }}</span>
								</div>
								<div class="previous-observations__approver">
									<img
										alt="avatar aprovador"
										class="previous-observations__avatar"
										[width]="28"
										[height]="28"
										[src]="getObservationApproverImage(item)"
									/>
									<div>
										<strong class="previous-observations__field-label">Aprovador</strong>
										<span class="previous-observations__field-value">{{ getObservationApproverLabel(item) }}</span>
									</div>
								</div>
							</div>

							<div class="previous-observations__note">
								<strong class="previous-observations__field-label">Observação</strong>
								<p>{{ getObservationNote(item) }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr />

			<h3 class="cards-title my-2">Projeção</h3>

			<div class="d-flex flex-row flex-wrap row mt-2 workscale-items">
				<ng-container *ngFor="let workScale of workScaleGroups; let i = index">
					<div class="flex flex-column col-md-6 workscale-item">
						<div class="flex flex-1 justify-space-between gap-2">
							<div class="icon-container">
								<i class="feather icon-clock"></i>
							</div>
							<span class="workscale-item-title">{{
								workScale.workScaleGroup
								}}</span>
						</div>

						<div class="card card-fit workscale-item-cards">
							<div class="card-header">
								<div class="flex-1 text-uppercase">Cargo / Função</div>
								<div class="flex-1 text-uppercase">Quantidade</div>
							</div>
							<div class="card-body px-0 py-1">
								<ng-container *ngIf="workScale.amounts.length > 0">
									<ng-container *ngFor="
                      let item of workScale.amounts;
                      let isLast = last;
                      let j = index
                    ">
										<div class="flex justify-content-between align-items-center workscale-item-infos">
											<div class="flex-1">
												<span class="text-sm">{{ getJobLabel(item) }}</span>
											</div>
											<div class="flex-1 value-container">
												<ng-container *ngIf="showsPreviousAmount(item)">
													<span class="text-through">{{ item.previousAmount }}</span>
												</ng-container>

												<span [ngClass]="getAmountCssClass(item)">{{
													isAmountRemoved(item) ? (item.newAmount ?? 0) : item.newAmount
												}}</span>

												<i *ngIf="isAmountAdded(item)" data-feather="plus" class="mb-icon text-primary"
													size="14"></i>
												<i *ngIf="item.changeDirection === 'increase'" data-feather="arrow-up" class="mb-icon text-success"
													size="14"></i>
												<i *ngIf="item.changeDirection === 'decrease'" data-feather="arrow-down" class="mb-icon text-danger"
													size="14"></i>
												<i *ngIf="isAmountRemoved(item)" data-feather="minus" class="mb-icon text-danger"
													size="14"></i>
											</div>
										</div>

										<hr *ngIf="!isLast" />
									</ng-container>
								</ng-container>
								<ng-container *ngIf="!workScale.amounts.length">
									<div class="card-body-empty flex justify-content-center align-items-center">
										<span> Nenhuma posição incluída.</span>
									</div>
								</ng-container>
							</div>
							<div class="card-footer flex align-items-center justify-content-between">
								<span>Total HC: {{ getTotalHadCount(workScale) }}</span>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</div>
